import request from '@/utils/request'

// 我的收藏列表

export function getCollectionList(params) {
  return request({
    url: '/sc/ticketMain/api/factSc/page',
    method: 'get',
    headers: {
      isToken: true
    },
    params: params
  })
}
// 取消收藏

export function getDelCollection(data) {
  return request({
    url: '/sc/ticketMain/api/factSc/delete',
    method: 'post',
    headers: {
      isToken: true
    },
    data: data
  })
}
